module.exports = __webpack_public_path__ + "media/images/adform_logo-7e6a74414ccf3109e6258d0606130c74.png";